import { Mode, Range, PitchClassName } from "../../lib/music";
import { getScalePattern, getStepPattern, getCanonicalScientificPitchNotation } from "../../lib/music/util";
import { pitchClass } from '../../lib/music/piano/keyboard';

// determine keys based on key, type, mode, range and hand toggles
const useHighlightedKeys = (
  keys: Array<number>,
  keyName?: PitchClassName,
  mode?: Mode,
  range?: Range,
  showLeftHand?: boolean,
  showRightHand?: boolean
) => {
  if (!keyName || !range || !mode) {
    return [];
  }

  const modeMask = getScalePattern(mode);
  const rangeMask = getStepPattern(range);
  const highlightedKeys: Array<number> = [];

  if (modeMask.length === 0 || rangeMask.length === 0) {
    return [];
  }

  // Get to first key of pitch class
  let keyIndex = keys.findIndex((k, i) =>
       pitchClass(k) === getCanonicalScientificPitchNotation(keyName)
    && i > 1
  );

  for (let i = 0, j = 0; i < rangeMask.length; i++, j++) {
    let nextStep = modeMask[j % modeMask.length];

    while (!nextStep) {
      j++;
      keyIndex++
      nextStep = modeMask[j % modeMask.length];
    }

    const nextActiveKey = keys[keyIndex]

    if (nextActiveKey && rangeMask[i]) {
      highlightedKeys.push(nextActiveKey);
    }

    keyIndex++;
  }

  return highlightedKeys;
};

export default useHighlightedKeys;
